/**
 * @generated SignedSource<<278f273f7c0e6cd7ff83bc0054ff0069>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetUserAcceptableUseAgreedInput = {
  clientMutationId?: string | null | undefined;
};
export type useSetUserAcceptableUseAgreedMutation$variables = {
  input: SetUserAcceptableUseAgreedInput;
};
export type useSetUserAcceptableUseAgreedMutation$data = {
  readonly setUserAcceptableUseAgreed: {
    readonly clientMutationId: string | null | undefined;
    readonly user: {
      readonly acceptableUseAgreedAt: any | null | undefined;
      readonly updatedAt: any;
    } | null | undefined;
  } | null | undefined;
};
export type useSetUserAcceptableUseAgreedMutation = {
  response: useSetUserAcceptableUseAgreedMutation$data;
  variables: useSetUserAcceptableUseAgreedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptableUseAgreedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSetUserAcceptableUseAgreedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserAcceptableUseAgreedPayload",
        "kind": "LinkedField",
        "name": "setUserAcceptableUseAgreed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSetUserAcceptableUseAgreedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SetUserAcceptableUseAgreedPayload",
        "kind": "LinkedField",
        "name": "setUserAcceptableUseAgreed",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17b3e0128f2acfcab6a3727836e5ad49",
    "id": null,
    "metadata": {},
    "name": "useSetUserAcceptableUseAgreedMutation",
    "operationKind": "mutation",
    "text": "mutation useSetUserAcceptableUseAgreedMutation(\n  $input: SetUserAcceptableUseAgreedInput!\n) {\n  setUserAcceptableUseAgreed(input: $input) {\n    clientMutationId\n    user {\n      acceptableUseAgreedAt\n      updatedAt\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa4c738c842a5778e6b0231033f547c2";

export default node;
